export function ToolbarMenu() {
  // Toolbar menu removed - navigation is handled by sidebar
  return null;
}